const commonUtil = {

  appId: {
    dev: 'dingoatf66acoadfn8lzl3bkc',
    qa: 'dingoalib8d1qad2m8pu4acg',
    stag: '',
    online: 'wxb93739590cbc39d1',
    // online: 'wxb3e66b61a417bd20',
  },
  gender: [
    '', '男', '女'
  ],
  getAppId: function() {
    let currPath = window.location.origin;
    console.log(currPath);
    if (currPath.indexOf('info3') > -1) {
      return 'wxb93739590cbc39d1';// 南京
    } else if (currPath.indexOf('info4') > -1) {
      return 'wx69a84545aee9ed80';// 青岛
    } else if (currPath.indexOf('info5') > -1) {
      return 'wx25204369eecbbf98';// 北京
    } else if (currPath.indexOf('info6') > -1) {
      return 'wxb4e122569bc51cf5';// 成都
    } else if (currPath.indexOf('info7') > -1) {
      return 'wx7dc4ccb856c0eae5';// 长沙
    } else if (currPath.indexOf('info8') > -1) {
      return 'wxf48feabb40e5eb04';// 奇致
    } else if (currPath.indexOf('info2') > -1 || currPath.indexOf('localhost:8088') > -1) {
      return 'wxee31a0fcd0aefe74'; // 测试
    }
    return '';
  },
  getHospitalId: function() {
    let currPath = window.location.origin;
    if (currPath.indexOf('info3') > -1) {
      return 3;
    } else if (currPath.indexOf('info4') > -1) {
      return 4;
    } else if (currPath.indexOf('info5') > -1) {
      return 5;
    } else if (currPath.indexOf('info6') > -1) {
      return 6;
    } else if (currPath.indexOf('info7') > -1) {
      return 7;
    } else if (currPath.indexOf('info8') > -1) {
      return 8;
    } else if (currPath.indexOf('info2') > -1 || currPath.indexOf('localhost:8088') > -1) {
      return 2;
    }
    return -1;
  },
  setBackImg: function (param) {
    let hosId = this.getHospitalId()==2 ? 3 : this.getHospitalId();
    return 'background:url(/static/img/' + param + hosId +'.jpg) no-repeat top center #fff; background-size:100% auto';
  }
};


export default commonUtil



// WEBPACK FOOTER //
// ./src/utils/commonUtil.js